
import { defineComponent, ref, Ref, onMounted } from "vue";
import BaseButton from "@/components/BaseButton.vue";
import { Editor } from "@/game";
import { useUserLevel } from "@/hooks/use-user-level";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "EditorPage",
  components: { BaseButton },
  setup() {
    let editor: Editor | null = null;
    const canvas: Ref<HTMLCanvasElement | null> = ref(null);
    const router = useRouter();
    const { userLevel, setUserLevel } = useUserLevel();

    const saveLevelAndRedirect = (): void => {
      if (editor) {
        setUserLevel(editor.getLevel());
      }
      router.push("/game");
    };

    onMounted(() => {
      editor = new Editor(canvas.value as HTMLCanvasElement, {
        userLevel: userLevel.value,
      });
    });

    return {
      canvas,
      saveLevelAndRedirect,
    };
  },
});
